"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Exception = void 0;
class Exception {
    constructor(message, wrapped) {
        this.message = message;
        this.wrapped = wrapped;
    }
}
exports.Exception = Exception;
//# sourceMappingURL=exception.js.map